import { createFileRoute } from '@tanstack/react-router';

import { TemplateEditorPage } from '@/features/admin/assessments/TemplateEditorPage';

function EditTemplateRoute() {
  const { templateId } = Route.useParams();
  return <TemplateEditorPage templateId={templateId} />;
}

export const Route = createFileRoute('/_authed/admin/assessments/$templateId/edit')({
  component: EditTemplateRoute,
});
